module.exports = __webpack_public_path__ + "7792d20c9fd32055d281af1b7d5e24ea.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/japanese-restaurant-empty.png
// module id = 2830
// module chunks = 0